/**
 * B2B product navigation: desktop opens product details in a new browser tab;
 * mobile uses same-tab navigation and native browser Back.
 * Delegated click handler also supports dynamically generated search/collection cards.
 */
(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || event.button !== 0) return;
    const link = event.target.closest('a[href]');
    if (!(link instanceof HTMLAnchorElement) || link.hasAttribute('download')) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;

    if (desktopQuery.matches) {
      // Existing named targets remain untouched; normal product links open a new tab.
      if (link.target && !['_self', '_blank'].includes(link.target)) return;
      link.target = '_blank';
      link.rel = Array.from(new Set([...link.rel.split(' ').filter(Boolean), 'noopener'])).join(' ');
      link.dataset.ypProductTab = 'true';
    } else if (link.dataset.ypProductTab === 'true') {
      // Reset the link when resizing to mobile, restoring normal Back navigation.
      link.removeAttribute('target');
      delete link.dataset.ypProductTab;
    }
  }, { capture: true });
})();